var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-md-12"},[_c('MisComites')],1),_c('div',{staticClass:"col-xl-6 col-md-12"},[_c('MisDesigRevision')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }